import { connectHook } from 'app/common/components/connect-hook';
import { SimpleLink } from './simple-link';
import { useSimpleLink } from './simple-link-hook';

export default connectHook(SimpleLink, useSimpleLink);
